module.exports = __webpack_public_path__ + "static/media/websockets.19bdf17a.svg";